<template>
  <div>
    <!-- <web-view :src="urls"></web-view> -->
    <div>
      <iframe
        v-if="show"
        style="width: 100%; height: calc(100vh - 1.3rem); border: medium none"
        :src="urls"
      />
    </div>
    <Tab></Tab>
  </div>
</template>

<script>
  import { clientGet } from "@/api/seting";
  import Tab from "@/components/Tab.vue";
  import baseURL from "../api/baseUrl";

  export default {
    data() {
      return {
        urls: "",
        show: false,
      };
    },
    created() {
      this.url();
    },
    mounted() {},
    components: {
      Tab,
    },
    methods: {
      //获取链接
      url() {
        clientGet().then((res) => {
          if (res.status) {
            if (res.data) {
              if (res.data.customerServiceType == 0) {
                window.location.href = res.data.customerService;
              } else {
                this.show = true;
                this.urls = res.data.customerService;
              }
            }
          }
        });
      },
    },
  };
</script>

<style></style>
